import React from 'react';
import {
    Page,
    Card,
    ResourceItem,
    ResourceList,
    TextStyle,
    Filters,
    Tabs
} from '@shopify/polaris';
import { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { AppSettings } from '../../common/AppSettings';
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

function disambiguateLabel(key, value) {
    switch (key) {
        case 'operationFilter':
            return `Operation contains ${value}`;
        default:
            return value;
    }
}

function AutomationsIndexPage() {

    const history = useHistory();
    const [sortValue, setSortValue] = useState('DATE_MODIFIED_DESC');
    const [operationFilterValue, setOperationFilterValue] = useState(null);
    const [queryValueValue, setQueryValueValue] = useState(null);
    const [automationsValue, setAutomationsValue] = useState([]);
    const [selected, setSelected] = useState(0);
    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelected(selectedTabIndex),
        [],
    );

    let items = automationsValue
        .filter(_ => queryValueValue == null || _.name.toUpperCase().includes(queryValueValue.toUpperCase()))
        .map((item, index) => {
            return {
                id: item.id,
                name: item.name,
                url: null,
                created: new Date(item.dateCreated),
                index: item.index
            }
        }).sort((a, b) => sortValue === 'DATE_MODIFIED_DESC' ? b.created - a.created : a.created - b.created);

    useEffect(() => {

        fetch(`${AppSettings.ApiHost}/api/automations`, {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + Cookies.get("__genie")
            })
        })
            .then(response => response.json())
            .then(data => setAutomationsValue(data));
    }, []);

    const filterControl = getFilterControl();

    const tabs = [
        {
            id: 'all-operations',
            content: 'All',
            accessibilityLabel: 'All operations',
            panelID: 'all-operations-content-1',
        }
    ];


    return (
        <div>
            <Helmet>
                <title>Tag Genie - Tag Operations</title>
            </Helmet>
            <Page
                title="Automation"
                primaryAction={{ content: 'Create Automation', onAction: handleCreateOperation }}>
                <Card>
                    <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                        <Card.Section>
                            <React.Fragment>
                                {filterControl}
                                <ResourceList
                                    resourceName={{ singular: 'automation', plural: 'automations' }}
                                    items={items}
                                    renderItem={renderAutomationItem}
                                    sortValue={sortValue}
                                    sortOptions={[
                                        { label: 'Newest', value: 'DATE_MODIFIED_DESC' },
                                        { label: 'Oldest', value: 'DATE_MODIFIED_ASC' },
                                    ]}
                                    onSortChange={(selected) => {
                                        setSortValue(selected);
                                    }}
                                />
                            </React.Fragment>
                        </Card.Section>
                    </Tabs>

                </Card>
            </Page>
        </div >
    );

    function handleCreateOperation() {
        history.push("/automations/new");
    }

    function renderAutomationItem(item) {
        const { id, index, name } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => handleItemClick(e, item)}>
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <TextStyle variation="strong">#{index} {name}</TextStyle>
                        </div>
                    </div>
                </div>
            </ResourceItem>
        );
    }

    function handleItemClick(e, item) {
        history.push(`/automations/${item.id}`);
    }

    function getFilterControl() {

        const filters = [];
        const appliedFilters = !isEmpty(operationFilterValue)
            ? [
                {
                    key: 'operationDescriptionFilter',
                    label: disambiguateLabel('operationDescriptionFilter', operationFilterValue),
                    onRemove: handleOperationFilterRemove,
                },
            ]
            : [];

        return <Filters
            focused={true}
            queryValue={queryValueValue}
            queryPlaceholder="Filter automations by name"
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={setQueryValueValue}
            onQueryClear={() => { setQueryValueValue(null) }}
            onQueryBlur={() => { }}
            onClearAll={handleClearAll} >
        </Filters>
    }

    function handleClearAll() {
        setQueryValueValue(null);
        setOperationFilterValue(null);
    }

    function handleOperationFilterRemove() {
        setOperationFilterValue(null);
    }
}

export default AutomationsIndexPage;